<template>
  <div class="SpInput" :disabled="disabled" :style="style" :class="themeClass" @click="focus">
    <template v-if="textType=='text'||textType=='number'">
      <slot name="suffixLeft" />
      <input ref="inputref" v-model="model" :disabled="disabled" :name="name" class="fs-int" :style="{...inputStyle, ...textStyle}"
             :placeholder="placeholder"
             :type="isPwd?'password':'text'"
             @change="input" @blur="blur" @focus="focusevent">
      <i v-if="password && model" class="iconfont" :class="eyeType" @click="eyeClick" />
      <i v-if="showClear" class="icon-chacha iconfont" style="font-size: 10px; font-weight: bold; position:relative; right: 2px" @click="clearClick" />
      <div v-if="suffix" style="font-size: 14px">{{ suffix }}</div>
      <slot name="suffixRight" />
    </template>
    <template v-else>
      <textarea v-if="!autoSize" ref="inputref" v-model="model" :disabled="disabled" :name="name" class="fs-int" :style="{...inputStyle, ...textStyle}"
                :placeholder="placeholder"
                :rows="row"
                @change="input" @blur="blur" @focus="focusevent" />
      <textarea v-else ref="inputref" v-model="model" :disabled="disabled" :name="name" class="fs-int" :style="{...inputStyle, ...textStyle}" style="box-sizing: content-box"
                :placeholder="placeholder"
                @change="input" @blur="blur" @focus="focusevent" />
    </template>
    <span v-if="showWordLimit" class="numLimit">{{ enteredNum }}/ {{ maxlength }}</span>
    <span v-if="errorMsg || cusErrorMsg" class="error-msg" :style="{width: width +'px', top: height + 'px'}">{{ errorMsg || cusErrorMsg }}</span>
  </div>
</template>

<script type="text/ecmascript-6">
import { computed, ref } from '@vue/reactivity'
import { useSize } from '@/mixins/size'
import useForm, { useFormItemProps } from '@/hooks/useForm'
import { nextTick, toRef } from '@vue/runtime-core'
import { isNull, isNum, isValid } from '@/utils'
import { watch } from 'vue'

const THEME = {
  none: 'sp-none-style',
  primary: 'sp-color-bg-1 sp-color-pl-4',
  primary2: 'sp-color-bd-1-solid-1',
  primary3: 'sp-color-bg-2-1',
  warn: 'sp-color-bg-6',
  warn2: 'sp-color-bg-6-6',
  warn3: 'sp-color-bg-2-6',
  warn4: 'sp-color-bd-1-solid-6',
  warn45: 'sp-color-warn-5',
  gray: 'sp-color-bg-5',
  gray2: 'sp-color-bg-6-5',
  gray16: 'sp-color-bg-16',
  gray3: 'sp-color-bd-1-solid-5',
  grayBorder1: 'sp-color-bd-1-solid-7',
  grayBorder18: 'sp-color-bd-1-solid-18-3',
  gragbgE55: 'sp-color-E5-5',
  bottomBorder1: 'sp-color-bdb-1-solid-7',
  bottomBorder2: 'sp-color-bdb-1-solid-8',
  bottomBorder3: 'sp-color-bdb-1-solid-9'
}

// const useShowErrorMessage = () => {
//   function throttle (fn, delay = 300) {
//     let canRun = true
//     let ret = null
//     let timer = null
//     return function () {
//       return {
//         run: () => {
//           if (!canRun) return
//           canRun = false
//           ret = fn.call(this, arguments)
//           timer = setTimeout(() => {
//             canRun = true
//           }, delay)
//         },

//         clear: () => {
//           ret && ret.close()
//           canRun = true
//           timer && clearTimeout(timer)
//         }
//       }
//     }
//   }

//   const showErrorMessage = throttle(() => {
//     return Message({
//       type: 'error',
//       message: '输入格式不正确！',
//       duration: 3000
//     })
//   }, 3000)
//   return showErrorMessage
// }

const useFunction = (emit, {
  inputref,
  model
}) => {
  function input () {
    emit('input', model.value)
  }

  function blur () {
    emit('blur', model.value)
  }

  function focus () {
    inputref.value.focus()
  }

  function focusevent (e) {
    emit('focus', e)
  }

  return {
    input,
    blur,
    focus,
    focusevent
  }
}

export default {
  name: 'SpInput',

  nameSpace: 'SpInput',

  props: {
    type: {
      type: String,
      default: ''
    },

    disabled: {
      type: Boolean,
      default: false
    },

    showWordLimit: {
      type: Boolean,
      default: false
    },

    maxlength: Number,

    password: Boolean,

    textType: {
      type: String,
      default: 'text'
    },

    row: {
      type: String,
      default: '3'
    },

    autoSize: {
      type: Boolean,
      default: false
    },

    width: { // 0-1为百分比，>1为px
      type: [Number, String],
      default: 1
    },

    height: {
      type: [Number, String],
      default: 50
    },

    modelValue: {
      type: String,
      default: () => null
    },

    placeholder: {
      type: String,
      default: ''
    },

    suffix: {
      type: String,
      default: ''
    },

    precision: {
      type: Number,
      default: 2
    },

    min: {
      type: Number,
      default: null
    },

    max: {
      type: Number,
      default: null
    },

    showClear: {
      type: Boolean,
      default: false
    },

    textStyle: {
      type: Object,
      default: () => {
        return null
      }
    },

    cusErrorMsg: {
      type: String,
      default: ''
    },

    ...useFormItemProps()
  },

  emits: ['update:modelValue', 'input', 'change', 'focus', 'blur'],
  setup (props, { emit }) {
    // const showErrorMessage = useShowErrorMessage()
    const modelLocal = ref('')
    const model = computed({
      get: () => {
        if (props.modelValue === null) {
          modelLocal.value = null
        }
        // if (props.modelValue) {
        //   return props.modelValue
        // }
        // modelLocal.value = props.modelValue
        // formModel.set(props.modelValue, props.name)

        return field?.model || formModel.get(props.name) || (props.modelValue !== null ? props.modelValue : modelLocal.value)
      },
      set: (val) => {
        let checkNum = true
        if (isValid(val) && props.textType === 'number') {
          if (!isNum(val)) {
            errorMsg.value = 'number accepted only'
            return
          }
          const numVal = parseFloat(val)
          if ((!isNull(props.min) && props.min > numVal) || (!isNull(props.max) && props.max < numVal)) {
            errorMsg.value = `min:${props.min}, max:${props.max} `
            checkNum = false
            emit('change', val)
            emit('update:modelValue', val)
            if (formModel) {
              formModel.set(val, props.name)
            }
            if (field?.model) {
              field.model = val
            }
            modelLocal.value = val

            return
          }
          if (!new RegExp(`^-?(\\d*)\\.?(\\d{0,${props.precision}})$`, 'g').test(val)) {
            errorMsg.value = `precision:${props.precision}`
            emit('change', val)
            emit('update:modelValue', val)
            checkNum = false
            return
          }
        }
        emit('change', val)
        emit('update:modelValue', val)
        if (formModel) {
          formModel.set(val, props.name)
        }
        if (field?.model) {
          field.model = val
        }
        modelLocal.value = val
        nextTick(() => {
          if (errorMsg.value && !validate() && checkNum) { // 输入验证通过去除红框
            errorMsg.value = ''
          }
        })
      }
    })

    const enteredNum = ref(0)
    const {
      errorMsg,
      validate,
      formModel,
      field
    } = useForm(toRef(props, 'name'), 'input', model, props.required,
      props.validateReg, props.errorMsgFun, props.textType, props.precision, props.min, props.max)

    // watch(() => model.value, (nv, ov) => {
    //   if (props.autoSize) {
    //     resizeHeight()
    //   }
    //   if (props.showWordLimit) {
    //     if (model.value) {
    //       enteredNum.value = nv.length
    //       if (!props.disabled && nv.length > props.showWordLimit) {
    //         model.value = nv.substr(0, props.maxlength)
    //       }
    //     } else {
    //       enteredNum.value = 0
    //     }
    //   }
    //
    //   validate(errorMsg.value)
    // })
    const {
      widthC,
      heightC
    } = useSize(props.width, props.height)

    const style = computed(() => {
      // 自定义style
      const style = {}
      // 宽高
      if (!style.width && props.width !== 0) {
        style.width = widthC.value
      }
      // textarea不设置高度，由row定义
      if (!style.height && props.height !== 0 && props.textType.toLowerCase() !== 'textarea') {
        style.height = heightC.value
      }
      return style
    })
    // const { classes, style, inputClasses, inputStyle } = useStyle(props.type, props.popStyle, props.popClass, props.width, props.height, props.textType, props.popInputClass, props.popInputStyle)
    const inputref = ref(null)

    const {
      input,
      blur,
      focus,
      focusevent
    } = useFunction(emit, {
      inputref,
      model
    })
    const eyeType = ref('icon-eye')
    const eyeClick = () => {
      eyeType.value = eyeType.value === 'icon-eye' ? 'icon-close-eye' : 'icon-eye'
      isPwd.value = !isPwd.value
    }
    const isPwd = ref(props.password)

    const clearClick = () => {
      modelLocal.value = null
      model.value = null

      emit('update:modelValue', null)
      emit('change', null)
      emit('clear')
    }
    const resizeHeight = () => {
      nextTick(() => {
        const textArea = inputref.value
        const scrollHeight = textArea.scrollHeight // 控件所有的高度，包含滚动的那部分(不可见也会有高度)
        const height = textArea.offsetHeight // 屏幕上显示的高度
        if (height < scrollHeight) {
          textArea.style.height = scrollHeight - 30 + 'px' // 恢复默认值，这个作用就是根据内容自适应textarea高度
          textArea.style.height = scrollHeight - 30 + 'px' // 拿到最新的高度改变textarea的高度
        }
      })
    }
    if (props.autoSize) {
      resizeHeight()
    }
    return {
      eyeType,
      eyeClick,
      isPwd,
      themeClass: computed(() => [THEME[props.type] || 'none', { 'sp-color-error': !!errorMsg.value }]),
      model,
      style,
      input,
      blur,
      focus,
      errorMsg,
      inputref,
      focusevent,
      validate,
      clearClick,
      enteredNum,
      field
    }
  }
}
</script>

<style scoped lang="less">
.icon-chacha {
  transform: scale(0.8);
}
.SpInput {
  display: inline-flex;
  align-items: center;
  position: relative;

  &[disabled='true'] :hover {
    cursor: not-allowed;
  }
  .numLimit{
    font-size: 8px;
    position: absolute;
    right: 1em;
    bottom: 0.5em;
    color: #676767;
    opacity: 0.6;
  }
  .error-msg {
    position: absolute;
    left: 5px;
    bottom: 2px;
    color: red;
    font-size: 10px;
  }

  > input, textArea {
    border: none;
    outline: none;
    font-size: 16px;
    width: 100%;
    height: 100%;
    background-color: transparent;
  }

  > input {
    text-indent: 0.5em;
  }

  > textArea {
    padding: 1em 1em 1em 1em;
    resize: none;
  }
}

// type-style
.none {
  border: 1px solid black;
}
</style>
